import api from '../helpers';
import { sortBy } from 'lodash';

export default {
  list: {
    key: 'fetchIndustries',
    query: () => {
      return api.get('/api/industries', {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return sortBy(data, (item) => item.label.toLowerCase());
    },
  },
};
